import React, { Suspense } from "react"
import { Provider } from "react-redux"
import { PublicClientApplication } from "@azure/msal-browser"
import { MsalProvider } from "@azure/msal-react"
import { msalConfig } from "./src/auth/authConfig"
import { CustomNavigationClient } from "./src/utils/NavigationClient"
import store from "./src/store/ReduxStore"
import GlobalContextProvider from "./src/store/GlolbalContextProvider"
import { HTML5Backend } from "react-dnd-html5-backend"
import { TouchBackend } from "react-dnd-touch-backend"
import { DndProvider } from "react-dnd"
import { isMobile } from "react-device-detect"
import ClarityService from "./src/services/clarity/initialize-clarity"

const msalInstance = new PublicClientApplication(msalConfig)

/**
 * onInitialClientRender corre tras el primer render del cliente (árbol montado).
 * Microsoft Clarity se inicializa aquí, sin dependencia de Application Insights.
 */
export const onInitialClientRender = () => {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.log("[Clarity] onInitialClientRender: inicialización de Clarity")
  }
  ClarityService.initClarity()
}

export const wrapRootElement = ({ element }) => {
  const navigationClient = new CustomNavigationClient()
  msalInstance.setNavigationClient(navigationClient)
  const opts = {
    enableMouseEvents: true,
    enableTouchEvents: true,
  }

  return (
    <Suspense fallback="Loading...">
      <GlobalContextProvider>
        <DndProvider backend={isMobile ? TouchBackend : HTML5Backend} options={isMobile ? opts : ""}>
          <MsalProvider instance={msalInstance}>
            <Provider store={store}>{element}</Provider>
          </MsalProvider>
        </DndProvider>
      </GlobalContextProvider>
    </Suspense>
  )
}
